export default __webpack_public_path__ + "static/donut-4812b382d80c6efc899aa612be1b077a.svg";